import { PharmacyScreen } from '../features/checkout/PharmacyScreen'

export function CheckoutPharmacyPage() {
  return <PharmacyScreen />
}
